import { Container, ExpandableSection, Header, SpaceBetween } from '@amzn/awsui-components-react';
import { ReactNode } from 'react';

export interface ExpandableContainerProps {
  expandable?: boolean;
  defaultExpanded?: boolean;
  headerText?: string;
  headerInfo?: ReactNode;
}

export const ExpandableContainer: React.FC<ExpandableContainerProps> = (props) => {
  if (props.expandable) {
    return (
      <ExpandableSection
        {...props}
        defaultExpanded={props.defaultExpanded}
        headerText={props.headerText}
        headerInfo={props.headerInfo}
        variant="container"
      >
        {props.children}
      </ExpandableSection>
    );
  }

  const StaticHeader = () => (
    <Header variant="h2">
      <SpaceBetween size="s" direction="horizontal">
        <>{props.headerText}</>
        <>{props.headerInfo}</>
      </SpaceBetween>
    </Header>
  );

  return (
    <Container {...props} header={<StaticHeader />}>
      {props.children}
    </Container>
  );
};
